import { FulfillmentGroupColumnKey } from "@redotech/redo-fulfillment-common/fulfillment-group-column-keys";
import {
  getLotExpirations,
  getLotNumbers,
} from "@redotech/redo-fulfillment-common/lot/line-item-lots";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getLotExpirationDateUnitCell } from "@redotech/redo-fulfillment-operations-common/csv-columns/lot-expiration-date-csv";
import { getLotNumberUnitCell } from "@redotech/redo-fulfillment-operations-common/csv-columns/lot-number-csv";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { StringListCell } from "../cells/string-list-cell";

const lotNumberEntry = fgColumnEntries[FulfillmentGroupColumnKey.LOT_NUMBER];

export const LotNumberColumn: Column2<FulfillmentGroupData> = {
  key: lotNumberEntry.key,
  title: lotNumberEntry.title,
  renderNormalCell: ({ row }) => {
    const lotNumbers = getLotNumbers(row.items);
    if (lotNumbers.length === 0) {
      return null;
    }
    return <StringListCell displayName="lot number" strings={lotNumbers} />;
  },
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => <RedoTableTextCell text={getLotNumberUnitCell(row, expansionIndex)} />,
  width: lotNumberEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: lotNumberEntry.sortDirection,
};

const lotExpirationEntry =
  fgColumnEntries[FulfillmentGroupColumnKey.LOT_EXPIRATION_DATE];

export const LotExpirationDateColumn: Column2<FulfillmentGroupData> = {
  key: lotExpirationEntry.key,
  title: lotExpirationEntry.title,
  renderNormalCell: ({ row }) => {
    const expirations = getLotExpirations(row.items);
    if (expirations.length === 0) {
      return null;
    }
    return (
      <StringListCell displayName="lot expiration date" strings={expirations} />
    );
  },
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => (
    <RedoTableTextCell
      text={getLotExpirationDateUnitCell(row, expansionIndex)}
    />
  ),
  width: lotExpirationEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  sort: lotExpirationEntry.sortDirection,
};
